module.exports = __webpack_public_path__ + "img/btn_linelogin_big.85f781e6.svg";